import React, { useEffect, useState } from "react";
import "./resource.css";
import AddMore from "../../../assets/Icons/addMore.png";
import Remove from "../../../assets/Icons/minus.png";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";
export default function Machinery(props) {
  const [machineryList, setMachineryList] = useState([]);
  const [user, setUser] = useState("");
  const [machinary, setmachinary] = useState([
    {
      machinary: "",
      No_of_machinery: "",
      TaskID: props.subId,
      ProjectID: props.project.project_id,
      WPID: 0,
      User_Id: user?.user?.user_id,
    },
  ]);

  const addMoremachinery = (e) => {
    e.preventDefault();
    setmachinary([
      ...machinary,
      {
        machinary: "",
        No_of_machinery: "",
        TaskID: props.subId,
        ProjectID: props.project.project_id,
        WPID: 0,
        User_Id: user?.user?.user_id,
      },
    ]);
  };

  const RemoveMoremachinery = (index, e) => {
    e.preventDefault();
    const list = [...machinary];
    list.splice(index, 1);
    setmachinary(list);
  };

  const getMachinery = async () => {
    const machinery = await DPR_API.get_Resource_Machinery();
    if (machinery && machinery?.Machinery?.length) {
      setMachineryList(machinery?.Machinery);
    } else {
      setMachineryList([]);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("state");
    const userInfo = JSON.parse(user);
    setUser(userInfo);
  }, []);

  const selectChange = (index, e, type) => {
    const { name, value } = e.target;
    const list = [...machinary];
    list[index][name] = value;
    list[index]["TaskID"] = props.subId;
    setmachinary(list);
  };
  const inputChange = (index, e, type) => {
    const { name, value } = e.target;
    const list = [...machinary];
    list[index][name] = value;
    list[index]["TaskID"] = props.subId;
    setmachinary(list);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const create = await DPR_API.create_resource_machinery(machinary);
    if (create && create.status === 201) {
      toast.success(create?.message, { autoClose: 2000 });
      setTimeout(() => {
        props.closeM(false);
      }, 2500);
    }
  };

  useEffect(() => {
    getMachinery();
  }, []);

  return (
    <React.Fragment>
      {machinary?.map((val, x) => (
        <>
          <div className="row m-3">
            <div className="col-12">
              <label className="label-custom">Machinery</label>
              <select
                value={val?.machinary}
                onChange={(e) => selectChange(x, e, "roleType")}
                name="machinary"
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>Select machinery</option>
                {machineryList?.length
                  ? machineryList.map((val) => (
                      <option value={val.machinery_id}>
                        {val?.machinary_name}
                      </option>
                    ))
                  : ""}
              </select>
            </div>
          </div>
          <div className="row m-3">
            <div className="col-12">
              <label className="label-custom">Number of Machinery</label>
              <input
                value={val?.No_of_machinery}
                onChange={(e) => inputChange(x, e, "resourceName")}
                name="No_of_machinery"
                type="text"
                className="form-control shadow-none"
              />
            </div>
          </div>
          <div className="row m-3">
            {machinary?.length !== 1 && (
              <div className="d-flex justify-content-end">
                <button
                  className="d-flex remove-more"
                  onClick={(e) => RemoveMoremachinery(x, e)}
                >
                  <div>
                    <img
                      src={Remove}
                      width={20}
                      height={20}
                      style={{
                        background: "red",
                        borderRadius: 40,
                        padding: 4,
                      }}
                    />
                  </div>
                  <div
                    className="my-auto"
                    style={{
                      color: "white",
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 2,
                    }}
                  >
                    Remove
                  </div>
                </button>
              </div>
            )}
          </div>
          <hr />
        </>
      ))}
      <div className="row m-3">
        <div className="d-flex justify-content-end">
          <button className="d-flex add-more" onClick={addMoremachinery}>
            <div>
              <img src={AddMore} width={20} height={20} />
            </div>
            <div
              className="my-auto"
              style={{
                color: "rgba(0, 0, 0, 1)",
                fontSize: 14,
                fontWeight: 500,
                marginLeft: 2,
              }}
            >
              Add More
            </div>
          </button>
        </div>
      </div>
      <div className="row mt-2">
        <div class="d-flex justify-content-center">
          <div style={{ margin: 10 }}>
            <button onClick={onSubmit} className="btn btn-primary">
              Submit
            </button>
          </div>
          <div style={{ margin: 10 }}>
            <button className="btn btn-danger">Cancel</button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
